import { render } from "./PrescriptionPrintTemplate1.vue?vue&type=template&id=46bab12c&scoped=true"
import script from "./PrescriptionPrintTemplate1.vue?vue&type=script&lang=js"
export * from "./PrescriptionPrintTemplate1.vue?vue&type=script&lang=js"

import "./PrescriptionPrintTemplate1.vue?vue&type=style&index=0&id=46bab12c&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46bab12c"]])

export default __exports__